import mustRender from './mustRender';

function invalidateSize(chartDoc, key, value) {
  const prop = chartDoc.rendering ? 'nextInvalidated' : 'invalidated';
  const array = chartDoc[prop][key];

  if (array === undefined) {
    chartDoc = chartDoc.setIn([prop, key], [value]);
  } else if (array.indexOf(value) === -1) {
    chartDoc = chartDoc.setIn([prop, key, array.length], value);
  }

  return chartDoc;
}

function invalidate(chartDoc, key, value) {
  if (!key || key === '*') {
    const keys = Object.keys(chartDoc.chart.sizes);
    keys.forEach((key) => {
      chartDoc = invalidateSize(chartDoc, key, value);
    });
  } else {
    chartDoc = invalidateSize(chartDoc, key, value);
  }
  // TODO: review mutations
  chartDoc = chartDoc.setIn(['mustRender'], mustRender(chartDoc));
  return chartDoc;
}

export default invalidate;
